
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zima",
      function () {
        return require("private-next-pages/zima.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zima"])
      });
    }
  